export * from './popup-loader.component';
export * from './popup-loader.module';